var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"light"},[_c('BaseIcon',{attrs:{"icon":_vm.iconName,"color":_vm.color,"size":"mlg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }